import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { PaginatorModule } from '../shared/components/paginator/paginator.module';
import { SearchModule } from '../shared/components/search/search.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AfterLoginSharedModule } from '../shared/after-login.shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ExpectedDeliveryDateComponent } from './expected-delivery-date/expected-delivery-date.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RejectionReasonComponent } from './rejection-reason/rejection-reason.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { FiltersComponent } from './filters/filters.component';
import { PrintBarcodeModalComponent } from './print-barcode-modal/print-barcode-modal.component';
import { AddressDetailsComponent } from './address-details/address-details.component';
import { OrderAmountDetailsComponent } from './order-amount-details/order-amount-details.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { MatTabsModule } from '@angular/material/tabs';
import { TeamListComponent } from './team-list/team-list.component';
import { OrderCancelConfirmComponent } from './order-cancel-confirm/order-cancel-confirm.component';

@NgModule({
  declarations: [ExpectedDeliveryDateComponent, RejectionReasonComponent,
    OrderDetailsComponent,FiltersComponent,PrintBarcodeModalComponent,AddressDetailsComponent,OrderAmountDetailsComponent,
    TeamListComponent, OrderCancelConfirmComponent],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatNativeDateModule,
    PaginatorModule,
    SearchModule,
    MatSelectModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    AfterLoginSharedModule,
    MatFormFieldModule,
    MatInputModule,
    PipesModule,
    MatTabsModule
  ],
  exports: [ExpectedDeliveryDateComponent, RejectionReasonComponent,OrderDetailsComponent,FiltersComponent,AddressDetailsComponent,OrderAmountDetailsComponent,OrderCancelConfirmComponent]
})
export class ModalsModule {}
